import { FC, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetSetupViewIdSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupViewIdSelector";
import { WidgetsViewsHierarchySelect } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/widgets-views-hierarchy-select/WidgetsViewsHierarchySelect";
import { normalizedCostWidgetSetupDataChangeThunk } from "@/store/dashboards/thunks/widgets/normalized-cost-widget/setup-change/normalizedCostWidgetSetupDataChangeThunk";

export const NormalizedCostWidgetsViewsHierarchySelect: FC = () => {
  const dispatch = useAppDispatch();
  const viewId = useAppSelector(normalizedCostWidgetSetupViewIdSelector);

  const changeHandler = useCallback(
    (id: string) => {
      dispatch(normalizedCostWidgetSetupDataChangeThunk({ viewId: id }));
    },
    [dispatch],
  );

  return (
    <WidgetsViewsHierarchySelect
      selectedItemId={viewId}
      onChange={changeHandler}
    />
  );
};
